// @ts-nocheck
import React from "react";
import {Redirect, Route} from "react-router-dom";
import KeyCloak from "./Keycloak";
import TicketeraItem from "../Ticketera/Menu/TicketeraItem";
import {useAuth} from "./State/AuthContext";


export function PrivateRouteFiliacion({ filiacionNegada, children, ...rest }) {
    const {esFiliacion,masDeUnaFiliacion} = useAuth();
    
    if(!filiacionNegada) return(
        <Route {...rest}>
        {KeyCloak.isLoggedIn() ?  children : KeyCloak.doLogin }
        </Route>
    );
    
    return (
    <Route {...rest}>
        {KeyCloak.isLoggedIn() ? (esFiliacion(filiacionNegada) && !masDeUnaFiliacion())  ?  <Redirect to="/" />  : children : KeyCloak.doLogin }
    </Route>
    );
}


